import { render, staticRenderFns } from "./VaKpi.vue?vue&type=template&id=4da7b997&scoped=true&"
import script from "./VaKpi.vue?vue&type=script&lang=ts&"
export * from "./VaKpi.vue?vue&type=script&lang=ts&"
import style0 from "./VaKpi.vue?vue&type=style&index=0&id=4da7b997&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4da7b997",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('4da7b997')) {
      api.createRecord('4da7b997', component.options)
    } else {
      api.reload('4da7b997', component.options)
    }
    module.hot.accept("./VaKpi.vue?vue&type=template&id=4da7b997&scoped=true&", function () {
      api.rerender('4da7b997', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/molecules/VaKpi.vue"
export default component.exports